const resource = '/admin/v1/companies';

export default $axios => ({
  index(payload = {}) {
    return $axios.post(`${resource}/search`, payload);
  },

  all() {
    return $axios.get(`${resource}/all`);
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload);
  },

  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },

  updateType(id, payload) {
    return $axios.put(`${resource}/${id}/update-type`, payload);
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  },

  updateRole({ id, role_id }) {
    return $axios.post(`${resource}/${id}/update-role`, {role_id})
  }
});
